module.exports = __webpack_public_path__ + "assets/somewhereElse.svg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/somewhereElse.svg
// module id = 359
// module chunks = 0